<template>
    <div class="form-group mb-0">
        <date-range-picker
            ref="DateRangePicker"
            v-model="dateRange"
            :opens="opens"
            :locale-data="locale"
            :showDropdowns="showDropdowns"
            :showWeekNumbers="showWeekNumbers"
            :linkedCalendars="linkedCalendars"
            :ranges="ranges"
        >
            <!--Optional scope for the input displaying the dates -->
            <div slot="input" slot-scope="DateRangePicker">
                {{ DateRangePicker.startDate | date }} - {{ DateRangePicker.endDate | date }}
            </div>
        </date-range-picker>
    </div>
</template>
<script>
    import moment from 'moment'
    import DateRangePicker from 'vue2-daterange-picker'
    import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'


    export default {
        components: {DateRangePicker},
        name: 'DashboardDateRangePicker',
        props: {
            value: {
                type: Object,
                required: true
            }
        },
        filters: {
            date (value) {
                let options = {year: 'numeric', month: 'short', day: 'numeric'};
                return Intl.DateTimeFormat('en-US', options).format(value)
            }
        },
        data() {
            return {
                opens: 'right',
                showDropdowns: false,
                showWeekNumbers: true,
                linkedCalendars: true,
                locale: {
                    direction: 'ltr', //direction of text
                    format: 'MMMM DD, YYYY', //fomart of the dates displayed
                    separator: ' - ', //separator between the two ranges
                    applyLabel: 'Apply',
                    cancelLabel: 'Cancel',
                    weekLabel: 'W',
                    customRangeLabel: 'Custom Range',
                    daysOfWeek: moment.weekdaysMin(), //array of days - see moment documenations for details
                    monthNames: moment.monthsShort(), //array of month names - see moment documenations for details
                    firstDay: 1, //ISO first day of week - see moment documenations for details
                    showWeekNumbers: true //show week numbers on each row of the calendar
                },
                ranges: { //default value for ranges object (if you set this to false ranges will no be rendered)
                    'Today': [moment(), moment()],
                    'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                    'This week': [moment().startOf('isoWeek'), moment().endOf('isoWeek')],
                    'Last week': [moment().subtract(1, 'week').startOf('isoWeek'), moment().subtract(1, 'isoWeek').endOf('isoWeek')],
                    'This month': [moment().startOf('month'), moment().endOf('month')],
                    'Last month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
                    'Last 3 month': [moment().subtract(3, 'months'), moment()],
                    'This year': [moment().startOf('year'), moment().endOf('year')],
                }
            }
        },
        mounted() {

            let picker = this.$refs.DateRangePicker;
            let pickerClickRange = picker.clickRange;

            picker.clickRange = function(value) {

                // hook before call
                pickerClickRange(value);
                // hook after call

                picker.changeLeftMonth({
                    month: value[0].month(),
                    year: value[0].year()
                });

            }

        },
        computed: {
            dateRange: {
                get() {
                    return this.value
                },
                set(dateRange) {
                    this.$emit('input', dateRange);
                    this.$emit('update', dateRange);
                }
            }
        }
    }
</script>

<style scoped>
    .vue-daterange-picker {
        width: 100%;
        white-space: nowrap;
    }
</style>

<style>
    .vue-daterange-picker .drp-calendar.col.right,
    .vue-daterange-picker .drp-calendar.col.left {
        padding: 5px 0;
    }
</style>
